import * as _ from 'lodash';
import { equipmentTypes } from '../objects/Equipment';
import { NoPartyOption } from '../objects/Party';

angular.module("tromanWeb").controller('ReportsController', ['reportService', 'ObjectCache', 'downloadService', function (reportService, ObjectCache, downloadService) {

    var self = this;
    self.isSaving = false;
    self.reports = null;
    self.report = null;
    self.args = null;
    self.enable = null;
    self.selectedParties = null;

    self.reportChanged = function reportChanged() {
        self.enable = self.report.params;
        self.args = reportService.getDefaultArguments(self.report);
        self.selectedParties = null;
    };

    function load() {
        self.equipmentTypes = equipmentTypes;

        reportService.getVisibleReports().then(function (reports) {
            self.reports = reports;
            self.report = self.reports[0];
            self.reportChanged();
        });

        ObjectCache.allOrganizations().then(function (data) {
            self.organizations = data;
        });

        ObjectCache.allParties().then(function (data) {
            self.parties = [NoPartyOption].concat(data);
        });

        ObjectCache.getOrganizationTypes().then(function (data) {
            self.organizationTypes = data;
        });

        ObjectCache.getMissionTypes().then(function (data) {
            self.missionTypes = data;
        });

        ObjectCache.allWageTypes().then(function (data) {
            self.wageTypes = data;
        });
    }

    self.canSave = function () {
        return self.form && self.form.$valid && !self.isSaving;
    };

    self.submit = function submit() {

        if (!self.canSave()) return;

        self.isSaving = true;
        self.error = null;

        var args = _.cloneDeep(self.args);
        if (self.selectedParties != null && self.selectedParties.length > 0) {
            args.Query.PartyIds = [];
            _.forEach(self.selectedParties, party => {
                if (party.Id === NoPartyOption.Id) {
                    args.Query.WithoutParty = true;
                } else {
                    args.Query.PartyIds.push(party.Id);
                }
            });
        }

        reportService
            .generate(self.report.Id, args)
            .then(function (rsp) {
                self.isSaving = false;
                downloadService.downloadBlob(rsp.blob, rsp.filename);
            })
            .catch(function (err) {
                self.error = err;
                self.isSaving = false;
            });
    };

    load();
}]);